"use strict";
/**
 * Enrollment, progress and the event stream.
 *
 * The design decision worth stating: progress is an append-only event log with
 * client-generated ids, and everything else — a completion percentage, a lab
 * score, "which step do learners get stuck on" — is derived from it. That is
 * what makes offline work: the client can write events with no server round
 * trip, and replaying a batch it already sent changes nothing.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENDER_TIERS = exports.PROGRESS_EVENT_TYPES = exports.ENROLLMENT_STATUSES = void 0;
exports.ENROLLMENT_STATUSES = ['active', 'completed', 'withdrawn'];
exports.PROGRESS_EVENT_TYPES = [
    'lesson_viewed',
    'lesson_completed',
    'block_answered',
    'lab_started',
    'lab_step_completed',
    'lab_completed',
    'course_completed',
];
exports.RENDER_TIERS = ['text', '2d', '2.5d', '3d'];
//# sourceMappingURL=learn.js.map